import script from "./Today.vue?vue&type=script&setup=true&lang=js"
export * from "./Today.vue?vue&type=script&setup=true&lang=js"

import "./Today.vue?vue&type=style&index=0&id=5573924c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.9_vue@3.5.9_webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5573924c"]])

export default __exports__